/*

  Quick JS by Jason @ freakdesign.
  Questions? Ping me on twitter: @freakdesign

  Relates to blog post:
  https://freakdesign.com.au/blogs/news/get-shipping-estimates-on-a-product-page

  Example:
  https://jasons-experiments.myshopify.com/products/alex-twill-pant-mariner

*/
(function(){

	"use strict";

	/* In case you want to output a bunch of things to the debug console */
	var debug = false;
	var cartCookie;

  	var shippingCalcExist = document.querySelector('.shipping-calc-wrapper');
	if(shippingCalcExist) return;

	/* The ID of the element that you want to add the shipping fields into */
  	var productSection = document.querySelector('.shopping-calculator');
	if(!productSection){ log('Could not find the element'); return }

	/* the main product select element */
	var productSelect = document.querySelector('.product-form form input[name="id"]');
	if(!productSelect){ log('Could not find the main select element'); return }

	/* create a message box */
	var shippingMessage = document.createElement('p');
	var shippingCountry = document.createElement('select');
	var shippingProvince = document.createElement('select');
	var shippingZip = document.createElement('input');

	/* We are just adding some dummy fields for example only. There's better ways to handle this */
	var initFields = function(){

		/* create the country picker */
		var countries = ['Brazil'];
		for (var i = 0; i < countries.length; i++) {
			shippingCountry.add(new Option(countries[i], countries[i], i===0));
		};
		shippingCountry.name = 'shipping_address[country]';

		/* create the province state picker */

		var provinces = ['Santa Catarina'];
		for (var i = 0; i < provinces.length; i++) {
			shippingProvince.add(new Option(provinces[i], provinces[i], i===0));
		};
		shippingProvince.name = 'shipping_address[province]';

		/* create the zip / postcode field */
		shippingZip.type = 'text';
		shippingZip.name = 'shipping_address[zip]';
		shippingZip.value = '';
		shippingZip.placeholder = 'Insira seu CEP';
		shippingZip.maxLength = '8';
		shippingZip.id = 'input_address_zip';

		/* create a wrapper for the fields */
		var shippingCalcWrapper = document.createElement('div');
		shippingCalcWrapper.className = 'shipping-calc-wrapper';

		/* create a title */
		var shippingCalcTitle = document.createElement('p');
		shippingCalcTitle.innerText = 'Calcular o frete e prazo:';
		shippingCalcTitle.classList.add('title_shipping-calc');

		/* create a get rates button */
		var shippingCalcButton = document.createElement('button');
		shippingCalcButton.innerText = 'Calcular';
		shippingCalcButton.className = 'button shippingCalcButton';
		shippingCalcButton.onclick=function(){
			if(!productSelect.value.length){ return false }
			if(shippingZip.value != ''){
				shippingCalcButton.innerText = 'Calculando...';
				shippingCalcButton.className += ' disabled';
			}
			cartCookie = getCookie('cart');
			var tempCookieValue = tempCookieValue || "temp-cart-cookie___" + Date.now();
			var fakeCookieValue = fakeCookieValue || "fake-cart-cookie___" + Date.now();

			/* if not found, make a new temp cookie */
			if(!cartCookie){ 
				log('no cookie found');
				updateCartCookie(tempCookieValue);
				cartCookie = getCookie('cart');
			}else{
				log('cookie found');
			}

			/* if found but has a weird length, bail */
			if(cartCookie.length < 32){ log('cart ID not valid');return }

			/* Change the cookie value to a new 32 character value */
			updateCartCookie(fakeCookieValue);
			log(getCookie('cart'));

			getRates(parseInt(productSelect.value));
			return false;
		};

		/* create some labels for the fields */
		var labelNames = ['CEP'];
		var labels = [];
		for (var i = 0; i < labelNames.length; i++) {
			var label = document.createElement('label');
			label.innerText = labelNames[i];
			labels.push(label);
		};

		shippingCalcWrapper.appendChild(shippingCalcTitle);
		// shippingCalcWrapper.appendChild(labels[0]);
		// shippingCalcWrapper.appendChild(shippingCountry);
		// shippingCalcWrapper.appendChild(labels[0]);
		// shippingCalcWrapper.appendChild(shippingProvince);
		// shippingCalcWrapper.appendChild(labels[1]);
		shippingCalcWrapper.appendChild(shippingZip);
		shippingCalcWrapper.appendChild(shippingCalcButton);
		shippingCalcWrapper.appendChild(shippingMessage);

		/* add to the page */
		productSection.appendChild(shippingCalcWrapper);

	};

	/* A console logging function */
	function log (a){
		if(!debug){ return }
		console.log(a);
	};

	/* get cookie by name */
	var getCookie = function(name) {
		var value = "; " + document.cookie;
		var parts = value.split('; '+name+'=');
		if (parts.length == 2) return parts.pop().split(";").shift();
	};

	/* update the cart cookie value */
	var updateCartCookie = function(a) {
		log('changing cart cookie value to: '+a);
		var date = new Date();
		date.setTime(date.getTime()+(14*86400000));
		var expires = '; expires='+date.toGMTString();
		document.cookie = 'cart='+a+expires+'; path=/';
	};

	/* reset the cart cookie value */
	var resetCartCookie = function(){
		updateCartCookie(cartCookie);
		log(getCookie('cart'));
	};

	/* get the rates */
	var getRates = function(variantId){
		/* add whatever sanity checks you need in addition to the one below */
		if(typeof variantId === 'undefined'){ return }

		/* the main quantity element */
		var productQuantity = document.querySelector('.quantity__input');

		var quantity = productQuantity ? parseInt(productQuantity.value):1;
		var addData = {
			'id':variantId,
			'quantity':quantity
		};

		fetch('/cart/add.js', {
			body: JSON.stringify(addData),
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
			},
			method: 'POST'
		}).then(function(response) {
			return response.json();
		}).then(function(json) {
			/* we have JSON */
			//console.log(json);
			/* Change the cookie value back to what it was */

			fetch('/cart/shipping_rates.json?' + new URLSearchParams({
				'shipping_address[country]':shippingCountry.value,
				'shipping_address[province]':shippingProvince.value,
				'shipping_address[zip]':shippingZip.value
			})).then(function(response) {
				return response.json();
			}).then(function(result) {
				if(result.shipping_rates && result.shipping_rates.length){
					let messageHtml = '<ul>'
					for (let i = 0; i < result.shipping_rates.length; i++) {
						const element = result.shipping_rates[i];
						if (element.delivery_days.length > 0) {
							if (element.delivery_days[0] == 1) {
								var deliveryDays = '<span>1 dia útil</span>'
							} else {
								var deliveryDays = `<span>${element.delivery_days[0]} dias úteis</span>`
							}
						}
						messageHtml += `
						<li> 
							${element.name} por R$ ${element.price.replace('.', ',')}
							<br>
							${deliveryDays?deliveryDays:''}
						</li>
						`;
						if (i === result.shipping_rates.length) {
							messageHtml += '</ul>'
						}
					}
					shippingMessage.innerHTML = messageHtml;
					document.querySelector('.shippingCalcButton').innerText = 'Calcular';
					document.querySelector('.shippingCalcButton').className = 'button shippingCalcButton';
				} else {
					let messageHtml = result.zip
					shippingMessage.innerHTML = messageHtml;
					document.querySelector('.shippingCalcButton').innerText = 'Calcular';
					document.querySelector('.shippingCalcButton').className = 'button shippingCalcButton';
				}
				resetCartCookie()
			}).catch(function() {
				resetCartCookie();
				shippingMessage.innerHTML = '';
				document.querySelector('.shippingCalcButton').innerText = 'Calcular';
				document.querySelector('.shippingCalcButton').className = 'button shippingCalcButton';
			})
		}).catch(function(err) {
			/* uh oh, we have error. */
			console.error(err);
			resetCartCookie()
		});

	};

	initFields();
})()